// extracted by mini-css-extract-plugin
export default {"tipContainer":"src-pages-SalesCannelVersion-SalesChannelEditorMaintenancePage-Config-style-module__tipContainer--PpsxW"};